// extracted by mini-css-extract-plugin
module.exports = {"novaTarefa":"Formulario_novaTarefa__319nU","inputContainer":"Formulario_inputContainer__2zzbc"};